import Interface from "../util/interface";

export default {
  data: {
    timeout : null
  },
  methods: {
    userLoginCheck(){
      let user = localStorage.getItem("user");
      user = JSON.parse(user)
      if (user.new_reg_complete !== 1) {
        this.$dialog.confirm({
            title: '需要登录',
            message: '登录后才能发表评论哦',
            confirmButtonText: "去登录"
          })
          .then(() => {
            sessionStorage.setItem("back-url", this.$route.path)
            this.$router.push({name: 'login'})
          })
          .catch(() => {
            // on cancel
          });
        return false
      }else{
        return true
      }
    },
    addInfo(from="live"){
      clearTimeout(this.timeout)
      console.log("addInfo")
      this.timeout = setTimeout(() => {
        //10秒
        let user = localStorage.getItem("user");
        if (user != null) {
          user = JSON.parse(user)
        }else{
          user = {}
        }
        if (user.new_reg_complete !== 1) {
          this.showAddConfirm(from)
          return false
        }else{
          return true
        }
      }, 10000)
    },
    showAddConfirm(from=""){
      let user = localStorage.getItem("user");
      if (user != null) {
        user = JSON.parse(user)
      }else{
        user = {}
      }
      sessionStorage.setItem("complete_from", from)
      this.$dialog.confirm({
        title: '完善信息',
        message: '根据国家实名制要求，为了更好地为您提供健康管理服务，需您完善真实信息。\n',
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
          sessionStorage.setItem("back-url", this.$route.path)
          this.goAddInfo(user)
        })
        .catch(() => {
          if(user.is_complete === 1){
            Interface.getData('get', Interface.user.reg_complete,{new_reg_complete:1})
            user.new_reg_complete = 1
            localStorage.setItem("user", JSON.stringify(user))
          }else{
            if(from == "live"){
              return;
            }
            if (window.history.length > 1) {
              this.$router.back();
            } else {
              this.$router.push({name:"home"});
            }
          }
        });
    },
    goAddInfo(user){
      if(user.mobile == ""){
        this.$router.push({name: 'login'})
      }else{
        this.$router.push({name: 'add-info'})
      }
    }
  },
  destroyed() {
    clearTimeout(this.timeout)
  }
}



// WEBPACK FOOTER //
// ./src/mixins/checkLogin.js